import { render, staticRenderFns } from "./ExportsPopUp.vue?vue&type=template&id=e1edbf4c&"
import script from "./ExportsPopUp.vue?vue&type=script&lang=js&"
export * from "./ExportsPopUp.vue?vue&type=script&lang=js&"
import style0 from "./ExportsPopUp.vue?vue&type=style&index=0&id=e1edbf4c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports